<template>
    <div v-if="isNavBarVisible" class="navigation-bar" :class="{ small: small }">
        <div class="navigation-bar-inner">
            <div class="navigation-bar-title">
                <router-link class="h1" :class="{ small: small }" to="/home"
                    @click="toggleButons(navigatinStore.tabs[0])">
                    Админ панель</router-link>
                <!-- <div class="desktop-toggle">
                    <image-button v-if="!small" :src="BarIcon" :hint="'Скрыть панель'" @click="toggleBar" />
                    <image-button v-else :src="BarIcon" :hint="'Раскрыть панель'" @click="toggleBar" />
                </div> -->
                <div class="mobile-close">
                    <image-button :src="CloseIcon" :hint="'Закрыть меню'" @click="closeNavBar" />
                </div>
            </div>


            <div class="buttons" v-if="!small">
                <div class="buttons" v-for="button in topTabs" :key="button.text">
                    <NavBarButton :text="button.text" :icon="button.icon" :path="button.path"
                        :active="activeTabId === button.id" @click="toggleButons(button)" />
                </div>
            </div>
            <div class="buttons" v-else>
                <div class="buttons" v-for="button in topTabs" :key="button.text">
                    <NavBarButton :icon="button.icon" :path="button.path" :active="activeTabId === button.id"
                        @click="toggleButons(button)" />
                </div>
            </div>

            <div class="bottom-section">
                <div class="buttons" v-if="!small">
                    <div class="buttons" v-for="button in bottomTabs" :key="button.text">
                        <NavBarButton :text="button.text" :icon="button.icon" :path="button.path"
                            :active="activeTabId === button.id" @click="toggleButons(button)" />
                    </div>
                </div>
                <div class="buttons" v-else>
                    <div class="buttons" v-for="button in bottomTabs" :key="button.text">
                        <NavBarButton :icon="button.icon" :path="button.path" :active="activeTabId === button.id"
                            @click="toggleButons(button)" />
                    </div>
                </div>
                <div class="version-info" :class="{ small: small }">
                    <span>v{{ version }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBarButton from '../ui/NavBarButton.vue'
import BarIcon from '@/assets/icons/Bar_Left.svg'
import CloseIcon from '@/assets/icons/Close_MD.svg'

import { useNavigationStore } from '@/store/NavigationStore.js'

export default {
    name: 'NavigationBar',

    components: {
        NavBarButton,
    },

    data() {
        return {
            BarIcon,
            CloseIcon,
            small: false,
            navigatinStore: useNavigationStore(),
            version: process.env.VUE_APP_VERSION,
        }
    },

    computed: {
        tabs() {
            return this.navigatinStore.visibleTabs
        },
        topTabs() {
            return this.tabs.filter(tab => !tab.bottom)
        },
        bottomTabs() {
            return this.tabs.filter(tab => tab.bottom)
        },
        isNavBarVisible() {
            return this.navigatinStore.isNavBarVisible
        },
        activeTabId() {
            return this.navigatinStore.activeTabId
        }
    },

    mounted() {
        this.navigatinStore.setActiveTab(localStorage.getItem('active_tab') || 'home')
        window.addEventListener('resize', this.handleResize);
    },

    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        handleResize() {
            const hiddenRoutes = ['start', 'login', 'register'];
            if (hiddenRoutes.includes(this.$route.name)) {
                this.navigatinStore.setNavBarVisible(false);
                return;
            }

            if (window.innerWidth > 768) {
                this.navigatinStore.setNavBarVisible(true);
            } else {
                this.navigatinStore.setNavBarVisible(false);
            }
        },
        toggleButons(tab) {
            // this.buttons.forEach(item => {
            //     item.active = false
            // })
            // button.active = true;
            this.navigatinStore.setActiveTab(tab.id)
            if (window.innerWidth <= 768) {
                this.closeNavBar();
            }
        },

        toggleBar() {
            this.small = !this.small
            this.$emit('toggleBar', this.small)
        },

        closeNavBar() {
            this.navigatinStore.setNavBarVisible(false);
        }
    }
}
</script>

<style lang="scss">
.navigation-bar {
    box-sizing: border-box;

    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100%;
    z-index: 1000;

    //плавныая анимация сужения 
    transition: width 0.3s ease-in-out;


    &.small {
        width: 76px;
    }

    .navigation-bar-inner {
        box-sizing: border-box;
        background-color: var(--color-bg);
        //border: solid 1px var(--color-bg);
        width: 100%;
        height: 100%;
        padding: 10px;

        display: flex;
        flex-direction: column;

        .bottom-section {
            margin-top: auto;
            width: 100%;
        }

        .version-info {
            padding: 10px 0;
            text-align: center;
            font-size: 12px;
            color: var(--color-text-dark);

            &.small {
                font-size: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .navigation-bar-title {
            display: flex;
            // align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            margin-bottom: 40px;

            .h1 {
                color: var(--color-text);
                font-weight: 800;

                &:hover {
                    cursor: pointer;
                    text-decoration: underline;
                }
            }
        }
    }

    .h1 {
        display: block;
        margin-left: 8px;
        transition: display 0.3s ease-in-out;
        transition-delay: 0.3s; // 👈 ждём пока закончится ширина

    }

    &.small .h1 {
        display: none;
        opacity: 0;
        transition-delay: 0s; // 👈 сразу исчезает
    }

    .buttons {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: start;
        width: 100%;
        gap: 3px;
    }

    .mobile-close {
        display: none;
    }

    @media (max-width: 768px) {
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5); // Overlay effect if needed, but inner has bg

        .navigation-bar-inner {
            width: 80%;
            max-width: 300px;
            box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
        }

        .desktop-toggle {
            display: none;
        }

        .mobile-close {
            display: block;
        }
    }
}
</style>
